import { MyPopup as Popup } from './StyledPopup'

export default Popup
